import { throttle } from 'lodash'; // use like this within a react component: 
// constructor(props){
//   super(props)
//   rerenderOnWindowResize(this)
// }

export default function rerenderOnWindowResize(that) {
  that.updateDimensions = throttle(function () {
    if (that.props.disabled) return;
    that.forceUpdate();
  }, 250);
  var componentDidMount = that.componentDidMount;
  var componentWillUnmount = that.componentWillUnmount;

  that.componentDidMount = function () {
    componentDidMount && componentDidMount.bind(that).apply(void 0, arguments);
    window.addEventListener("resize", that.updateDimensions);
  };

  that.componentWillUnmount = function () {
    componentWillUnmount && componentWillUnmount.bind(that).apply(void 0, arguments);
    window.removeEventListener("resize", that.updateDimensions);
  };
}